import {atomWithStorage, createJSONStorage} from 'jotai/utils';

export type ColumnElement = {
  name: string;
  active: boolean;
  defaultHidden: boolean;
};

type ColumnState = {
  [tableKey: string]: ColumnElement[];
};

export const columnState = atomWithStorage<ColumnState>(
  'ETableColumnsConfig',
  {},
  createJSONStorage(),
  {getOnInit: true}
);
